import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=3ff85bee&"
import script from "./PageBar.vue?vue&type=script&lang=js&"
export * from "./PageBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports